import { StubPage } from '../StubPage'
export function Roles() {
  return <StubPage title="Roles & Permissions" summary="Roles group a set of allowed API paths. Assign roles to users to control what they can access. The three built-in roles are business-leader (full access), event-manager, and mail-manager." />
}
